import React from 'react';

import ToggleSelector from '../../options-selectors/switch-selector.component';

import './national-forests-toggle.styles.scss';

export default function NationalForestsToggle({ visibility, setVisibility }) {
  return (
    <div id='national-forest-overlay-toggle-container'>
      <ToggleSelector
        id='national-forest-overlay-toggle'
        value={visibility}
        handleChangeSelection={setVisibility}
        label='Show National Forests'
        ariaLabel='Show National Forests'
      />
    </div>
  );
}